import { Location as NgLocation } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';

import { TranslocoDirective } from '@jsverse/transloco';

import { ROUTES } from '../../../definitions/constants/routes.constants';
import { UserConfigsStoreFacade } from '../../../stores/global-store/user-configs/user-configs-store.facade';
import { SidebarDisplayStore } from '../../../stores/signal-stores/sidebar-display-store/sidebar-display.store';

@Component({
  selector: 'app-header-view-switch',
  imports: [
    MatIcon,
    MatIconButton,
    TranslocoDirective,
    MatTooltip
  ],
  templateUrl: './header-view-switch.component.html',
  styleUrl: './header-view-switch.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HeaderViewSwitchComponent {
  protected readonly userConfigsFacade = inject(UserConfigsStoreFacade);
  protected readonly sidebarDisplayStore = inject(SidebarDisplayStore);
  private readonly ngLocation = inject(NgLocation);
  public router = inject(Router);
  private readonly window = window;

  public onSwitchButtonClicked(): void {
    this.userConfigsFacade.isInternalViewSignal()
      ? this.sidebarDisplayStore.showSwitchViewSidebar()
      : this.switchToInternalView();
  }

  private switchToInternalView(): void {
    this.ngLocation.go(ROUTES.REPLENISHMENT);
    this.window.location.reload();
  }
}
